import { jsxs, jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { Alignment } from "../../foundations/alignment.es.js";
import { PRIMARY_COLOR } from "../../foundations/constants.es.js";
import { theme } from "../../foundations/theme.es.js";
import useIsMobile from "../../hooks/use-is-mobile.es.js";
import { styledOptions } from "../../utils/styled-options/styled-options.es.js";
import { styled } from "@mui/material";
import { forwardRef } from "react";
import { Displaying } from "../../foundations/displaying.es.js";
import { Direction } from "../../foundations/direction.es.js";
const SCROLL_AREA_DEFAULT_COLOR = PRIMARY_COLOR;
const SCROLL_AREA_HEIGHT = 320;
const SCROLL_AREA_WIDTH = 640;
const ScrollPaperArea = forwardRef(function ScrollPaperArea2({
  color,
  title,
  children,
  ...rest
}, ref) {
  const isMobile = useIsMobile();
  const typographyStyles = isMobile ? theme.typography.subtitle1 : theme.typography.h6;
  return /* @__PURE__ */ jsxs(ScrollPaperAreaRoot, { ref, ...rest, sx: {
    width: isMobile ? SCROLL_AREA_HEIGHT : SCROLL_AREA_WIDTH
  }, children: [
    /* @__PURE__ */ jsx(ScrollPaperAreaHeader, { color, sx: {
      ...typographyStyles
    }, children: title }),
    /* @__PURE__ */ jsx(ScrollPaperAreaContent, { children })
  ] });
});
const ScrollPaperAreaRoot = styled("div")(({
  theme: theme2
}) => ({
  display: Displaying.flex,
  flexDirection: Direction.column,
  border: `1px solid ${theme2.palette.border.main}`,
  borderRadius: theme2.spacing(3),
  height: SCROLL_AREA_HEIGHT,
  maxHeight: SCROLL_AREA_HEIGHT,
  overflow: "hidden"
}));
const ScrollPaperAreaHeader = styled("div", styledOptions)(({
  color = SCROLL_AREA_DEFAULT_COLOR,
  theme: theme2
}) => ({
  borderBottom: `1px solid ${theme2.palette.border.main}`,
  backgroundColor: `${theme2.palette[color].light}`,
  color: `${theme2.palette[color].dark}`,
  textAlign: Alignment.center,
  padding: theme2.spacing(1, 5)
}));
const ScrollPaperAreaContent = styled("div")(({
  theme: theme2
}) => ({
  padding: theme2.spacing(4, 6),
  overflowY: "scroll"
}));
export {
  SCROLL_AREA_DEFAULT_COLOR,
  SCROLL_AREA_HEIGHT,
  SCROLL_AREA_WIDTH,
  ScrollPaperArea
};
//# sourceMappingURL=scroll-paper-area.es.js.map
